import axios from "axios";
import { InformacionSenescytTitulos, ResponseInformacionSenescytTitulos, RowsTitulosRegistrados } from "./TypesInformacionAcademica";
//URL
//URL
import configData from "config.json"
import { alertService } from "components/Varios/alert_service";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import { InformacionAcademicaData } from "components/InformacionAcademica";
import { handleHeader } from "../Convenios/functionsConvenios";


const URL_INFORMACION_TITULOS_PERSONA = "DatosGenerales/TitulosPersona/"

export async function  ObtenerInformacionTitulosRegistrados(tipoNivelAcademico:string,datosPersona:UserData){
    
    var respuesta:ResponseInformacionSenescytTitulos = {
        datos:[],
        status:500
    };

    try {
        const response = await axios.get(configData.SERVER_URL+  `${URL_INFORMACION_TITULOS_PERSONA + tipoNivelAcademico } `,{
            headers : handleHeader(datosPersona.token)    
        })

        respuesta.datos = response.data
        respuesta.status = 200
    } catch (error) {
        var error_any:any = error;
        var status:number = handle_error(error_any);
        var mensaje = "Ha ocurrido un inconveniente";
        switch (status) {
            case 0|-1:
                mensaje ="No ha sido posible contactar con el sevidor"
                break;
            case 400:
                mensaje = "La información envíada no es válida"
                break;
            case 409:
                mensaje = error_any.response.data
                break;
            case 500:
                mensaje ="Ha ocurrido un inconveniente. Intentelo más tarde"
            default:
                break;
        }
        respuesta = {...respuesta,status,errorMessage:mensaje}
    }
    return respuesta

}

export function ParseInformacionTableTitulos(informacion:InformacionSenescytTitulos[],informacionGuardad:InformacionAcademicaData[]){
    var respuestaParseo:RowsTitulosRegistrados[] = []
    
    try {
        respuestaParseo = informacion.map((informacionTitulos,indiceTitulos) => {
            var estaRegistrado:boolean = informacionGuardad.length !== 0 && informacionGuardad.find((val) => val.codsenescyt === informacionTitulos.numeroRegistro) !== undefined;
            return {
                numeroRegistro: informacionTitulos.numeroRegistro,
                fechaRegistro: informacionTitulos.fechaRegistro,
                nombreTitulo: informacionTitulos.nombreTitulo,
                estadoRegistroTitulo:  estaRegistrado?"R":"NR"
            }
        })
    } catch (error) {
        
    }
    return respuestaParseo;
}